export const createOptions = (serverResponse, value1, value2) =>
  (serverResponse &&
    serverResponse.map((item, i) => ({
      key: i,
      value: `${value1 ? item[value1] : item}`,
      text: `${value2 ? item[value2] : item}`,
    }))) ||
  [];



// WEBPACK FOOTER //
// ./src/utils/createOptions.js